import React from 'react';

import { SettingsListProps } from './settingsList.type';
import './settingsList.style.scss';

export const SettingsList = ({ children }: SettingsListProps) => <div className="settings-list">{children}</div>;
